import _ from 'lodash';

import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import {
  DepartureRoomCheckBasicInformation,
  DepartureRoomCheckDetails
} from './components';
import {
  MODALS,
  fetchDepartureRoomCheck,
  fetchDepartureRoomChecks,
  fetchBookingSet,
  REFETCH_ROOM_CHECK_DELAY,
  verifyDepartureRoomCheckImageUpload,
  removeDepartureRoomCheckImage,
  verifyDepartureRoomCheckInventoryUpload,
  verifyDepartureRoomCheckMaintenanceUpload,
  removeDepartureRoomCheckInventory,
  removeDepartureRoomCheckMaintenance,
  fetchDepositSummary,
  fetchRoomChecksTimeline
} from 'ducks/bookingSets';

import {MODALS as tenancyModals} from 'ducks/tenancy';

import {
  RoomCheckDetailImagesSection,
  RoomCheckDetailDocumentSection
} from 'containers/BookingSetDetail/components';

import {storeDataInModal, openModal, closeModal} from 'ducks/modals';
import {composeActions, delayedAction} from 'ducks/common';
import {uploadFile} from 'ducks/files';

import {
  signDepartureRoomCheckImage as signDepartureRoomCheckImageSdk,
  signDepartureRoomCheckInventoryDocument as signDepartureRoomCheckInventoryDocumentSdk,
  signDepartureRoomCheckMaintenanceDocument as signDepartureRoomCheckMaintenanceDocumentSdk
} from 'sdk/bookingSets';

import inventoryIcon from 'assets/icons/inventory-icon.svg';
import maintenanceIcon from 'assets/icons/maintenance-icon.svg';

import './styles.css';

class DepartureRoomCheckDetailModal extends React.Component<any> {
  componentDidMount() {
    const {bookingSetId, roomCheckId} = this.props.data;

    this.props.fetchDepartureRoomCheck(
      {bookingSetId, roomCheckId},
      this.fetchDepartureRoomCheckExtraActions()
    );
  }

  fetchDepartureRoomCheckExtraActions = () =>
    this.props.storeDataExtraActions(data => ({
      departureRoomCheck: data
    }));

  removeImage = ({imageId}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const extraActions = [
      () =>
        fetchDepartureRoomCheck(
          {roomCheckId, bookingSetId},
          this.fetchDepartureRoomCheckExtraActions()
        ),
      () => fetchDepartureRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId})
    ];

    this.props.removeDepartureRoomCheckImage(
      {
        bookingSetId,
        departureRoomCheckId: roomCheckId,
        roomCheckImageId: imageId
      },
      extraActions
    );
  };

  dropImage = ({image}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
        data: {
          uploadingImage: true
        }
      });

    const finishUploadingAction = () =>
      composeActions([
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () =>
              fetchDepartureRoomCheck(
                {roomCheckId, bookingSetId},
                this.fetchDepartureRoomCheckExtraActions()
              )
          }),
        ...this.props.storeDataExtraActions(() => ({
          uploadingImage: false
        })),
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () => fetchDepartureRoomChecks({bookingSetId})
          }),
        () => fetchBookingSet({bookingSetId})
      ]);

    const storeIdentifierAction = identifier => {
      const successExtraActions = [
        () =>
          storeDataInModal({
            modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
            data: {
              imageUploadError: null
            }
          })
      ];
      const failureExtraActions = [
        ({errors}) =>
          storeDataInModal({
            modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
            data: {
              imageUploadError: _.get(errors, '_error')
            }
          })
      ];

      return verifyDepartureRoomCheckImageUpload(
        {
          imageIdentifier: identifier,
          bookingSetId,
          departureRoomCheckId: roomCheckId
        },
        successExtraActions,
        failureExtraActions
      );
    };
    const signData = {
      filename: image.name,
      fileType: image.type,
      bookingSetId
    };

    this.props.uploadFile({
      file: image,
      signSdk: signDepartureRoomCheckImageSdk,
      signData,
      startUploadingAction,
      storeIdentifierAction,
      finishUploadingAction
    });
  };

  removeInventory = ({documentId}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const extraActions = [
      () =>
        fetchDepartureRoomCheck(
          {roomCheckId, bookingSetId},
          this.fetchDepartureRoomCheckExtraActions()
        ),
      () => fetchDepartureRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId})
    ];

    this.props.removeDepartureRoomCheckInventory(
      {
        bookingSetId,
        departureRoomCheckId: roomCheckId,
        roomCheckInventoryId: documentId
      },
      extraActions
    );
  };

  dropInventory = ({document}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
        data: {
          uploadingInventory: true
        }
      });

    const finishUploadingAction = () =>
      composeActions([
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () =>
              fetchDepartureRoomCheck(
                {roomCheckId, bookingSetId},
                this.fetchDepartureRoomCheckExtraActions()
              )
          }),
        ...this.props.storeDataExtraActions(() => ({
          uploadingInventory: false
        })),
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () => fetchDepartureRoomChecks({bookingSetId})
          }),
        () => fetchBookingSet({bookingSetId})
      ]);

    const storeIdentifierAction = identifier =>
      verifyDepartureRoomCheckInventoryUpload({
        documentIdentifier: identifier,
        bookingSetId,
        departureRoomCheckId: roomCheckId
      });

    const signData = {
      filename: document.name,
      fileType: document.type,
      bookingSetId
    };

    this.props.uploadFile({
      file: document,
      signSdk: signDepartureRoomCheckInventoryDocumentSdk,
      signData,
      startUploadingAction,
      storeIdentifierAction,
      finishUploadingAction
    });
  };

  removeMaintenance = ({documentId}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const extraActions = [
      () =>
        fetchDepartureRoomCheck(
          {roomCheckId, bookingSetId},
          this.fetchDepartureRoomCheckExtraActions()
        ),
      () => fetchDepartureRoomChecks({bookingSetId}),
      () => fetchBookingSet({bookingSetId}),
      () => fetchDepositSummary({bookingSetId}),
      () => fetchRoomChecksTimeline({bookingSetId})
    ];

    this.props.removeDepartureRoomCheckMaintenance(
      {
        bookingSetId,
        departureRoomCheckId: roomCheckId,
        roomCheckMaintenanceId: documentId
      },
      extraActions
    );
  };

  dropMaintenance = ({document}) => {
    const {bookingSetId, roomCheckId} = this.props.data;

    const startUploadingAction = () =>
      storeDataInModal({
        modalName: MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
        data: {
          uploadingMaintenance: true
        }
      });

    const finishUploadingAction = () =>
      composeActions([
        () =>
          delayedAction({
            delay: REFETCH_ROOM_CHECK_DELAY,
            action: () =>
              composeActions([
                () =>
                  fetchDepartureRoomCheck(
                    {roomCheckId, bookingSetId},
                    this.fetchDepartureRoomCheckExtraActions()
                  ),
                () => fetchDepartureRoomChecks({bookingSetId}),
                () => fetchBookingSet({bookingSetId}),
                () => fetchDepositSummary({bookingSetId}),
                () => fetchRoomChecksTimeline({bookingSetId})
              ])
          }),
        ...this.props.storeDataExtraActions(() => ({
          uploadingMaintenance: false
        }))
      ]);

    const storeIdentifierAction = identifier =>
      verifyDepartureRoomCheckMaintenanceUpload({
        documentIdentifier: identifier,
        bookingSetId,
        departureRoomCheckId: roomCheckId
      });

    const signData = {
      filename: document.name,
      fileType: document.type,
      bookingSetId
    };

    this.props.uploadFile({
      file: document,
      signSdk: signDepartureRoomCheckMaintenanceDocumentSdk,
      signData,
      startUploadingAction,
      storeIdentifierAction,
      finishUploadingAction
    });
  };

  openInvoiceDetailModal = () => {
    const {departureRoomCheck} = this.props.data;
    const {
      id,
      scheduleType,
      locationRef,
      tenancyId
    } = departureRoomCheck.invoiceReceivedAtFrontDesk;

    this.props.composeActions([
      () => closeModal(MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL),
      () =>
        openModal(
          tenancyModals.INVOICE_DETAIL,
          {
            scheduleType,
            invoiceId: id,
            locationRef,
            tenancyId
          },
          true
        )
    ]);
  };

  render() {
    const {
      departureRoomCheck,
      uploadingImage,
      uploadingInventory,
      uploadingMaintenance,
      bookingSetId,
      imageUploadError
    } = this.props.data;

    const {locationRef} = this.props;

    return (
      <Modal
        className="DepartureRoomCheckDetailModal"
        show={true}
        type={Modal.MEDIUM}
        onClose={this.props.closeModal}>
        <Modal.Header heading="Departure room check" />
        {departureRoomCheck && (
          <Modal.Body>
            <div className="DepartureRoomCheckDetailModal__section">
              <DepartureRoomCheckBasicInformation
                departureRoomCheck={departureRoomCheck}
                openInvoiceDetailModal={this.openInvoiceDetailModal}
              />
              <DepartureRoomCheckDetails
                departureRoomCheck={departureRoomCheck}
                bookingSetId={bookingSetId}
                locationRef={locationRef}
                fetchDepartureRoomCheckExtraActions={
                  this.fetchDepartureRoomCheckExtraActions
                }
                edittingDescription={this.props.editDescription}
              />
            </div>
            <div className="DepartureRoomCheckDetailModal__section">
              <RoomCheckDetailImagesSection
                imageUploadError={imageUploadError}
                images={departureRoomCheck.images}
                uploadingImage={uploadingImage}
                removeImage={this.removeImage}
                dropImage={this.dropImage}
              />
            </div>
            <div className="DepartureRoomCheckDetailModal__section">
              <RoomCheckDetailDocumentSection
                document={departureRoomCheck.inventory}
                uploadingDocument={uploadingInventory}
                removeDocument={this.removeInventory}
                dropDocument={this.dropInventory}
                documentIcon={inventoryIcon}
                placeholderText="Upload inventory"
                fileLabel="Inventory"
              />
            </div>
            <div className="DepartureRoomCheckDetailModal__section">
              <RoomCheckDetailDocumentSection
                document={departureRoomCheck.maintenance}
                uploadingDocument={uploadingMaintenance}
                removeDocument={this.removeMaintenance}
                dropDocument={this.dropMaintenance}
                documentIcon={maintenanceIcon}
                placeholderText="Upload maintenance report"
                fileLabel="Maintenance"
              />
            </div>
          </Modal.Body>
        )}
      </Modal>
    );
  }
}

const mapStateToModalData = (_state, data) => ({
  uploadingImage: _.get(data, 'uploadingImage', false),
  uploadingInventory: _.get(data, 'uploadingInventory', false),
  uploadingMaintenance: _.get(data, 'uploadingMaintenance', false)
});

const mapDispatchToProps = {
  fetchDepartureRoomCheck,
  removeDepartureRoomCheckImage,
  uploadFile,
  removeDepartureRoomCheckInventory,
  removeDepartureRoomCheckMaintenance,
  composeActions
};

export default withModal(
  MODALS.DEPARTURE_ROOM_CHECK_DETAIL_MODAL,
  mapStateToModalData,
  mapDispatchToProps
)(DepartureRoomCheckDetailModal);
